<template functional>
  <v-tooltip top>
    <template v-slot:activator="{on}">
      <v-btn
        class="nx-auth-drawer__btn ma-0"
        block
        depressed
        v-bind="data.attrs"
        v-on="{...listeners, ...on}"
      >
        <slot name="icon">
          <v-icon class="nx-auth-drawer__btn__icon">{{ props.icon }}</v-icon>
        </slot>
        <div class="nx-auth-drawer__btn__title">
          <slot name="title">{{ props.title }}</slot>
        </div>
      </v-btn>
    </template>
    <span>{{ props.title }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'NxAuthLoginMethodButton',
  functional: true,
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="stylus">
@import "../../../../assets/stylus/variables.styl";

.nx-auth-drawer__btn {
  &__title {
    display: none;
    text-transform: none;
    font-size: 15px
  }

  &.v-btn.v-btn--outline {
    border-color: $nx-neutral-500;

    &:before {
      background-color: transparent;
    }
  }
}

.xs12 {
  .nx-auth-drawer__btn {
    &__icon {
      margin-right: 8px
    }

    &__title {
      display: block;
    }
  }
}
</style>
